module.exports = __webpack_public_path__ + "img/rabbit.d7dc4a4c.svg";